import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/index/3-xl.avif")